import { IConfiguredHttp } from './http';

export type BrokerPropertyEventType = 'property' | 'availability' | 'pricing' | 'images' | 'marketing-preferences';

export interface IBrokerApi {
	sendPropertySyncEvent: (event: BrokerPropertyEventType, propertyId: string) => Promise<any>;
}

const propertyEventPayload = (event: BrokerPropertyEventType, propertyId: string) => {
	const base = { entity_type: 'property', type: 'property', id: propertyId };

	if (event === 'property') {
		return {
			...base,
			service: 'property',
			action: 'property_updated',
		};
	} else if (event === 'availability') {
		return {
			...base,
			service: 'availability',
			action: 'availability_updated',
		};
	} else if (event === 'images') {
		return {
			...base,
			service: 'image',
			action: 'images_updated',
		};
	} else if (event === 'pricing') {
		return {
			...base,
			service: 'pricing',
			action: 'pricing_updated',
		};

	} else if (event === 'marketing-preferences') {
		return {
			...base,
			service: 'marketing-preferences',
			action: 'marketing-preferences_updated',
		};
	}
	return {};
};

const brokerApiFactory = (http: IConfiguredHttp, prefix = ''): IBrokerApi => ({
	async sendPropertySyncEvent(event, propertyId) {
		if (propertyId === '0000') {
			throw new Error('test');
		}
		const payload = propertyEventPayload(event, propertyId);
		return http.post(`${prefix}/event`, payload);
	}
});

export default brokerApiFactory;
